import { cx } from "@/utils";
import Clickable, { ClickableProps } from "@components/Clickable";

import styles from "./Tabs.module.css";

export type TabHeadingProps = { active?: boolean } & ClickableProps;

const TabHeading: React.FunctionComponent<TabHeadingProps> = ({
  children,
  className,
  active = false,
  ...rest
}) => {
  return (
    <Clickable
      className={cx(styles.heading, className, { [styles.active]: active })}
      {...rest}
    >
      {children}
    </Clickable>
  );
};

export default TabHeading;
